module.exports = __webpack_public_path__ + "Logotjee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logotjee.png
// module id = 627
// module chunks = 0